import { render } from "./Caption.vue?vue&type=template&id=b3eb2ad0"
import script from "./Caption.vue?vue&type=script&lang=js"
export * from "./Caption.vue?vue&type=script&lang=js"

import "./Caption.vue?vue&type=style&index=0&id=b3eb2ad0&lang=css"
script.render = render

export default script